module.exports = __webpack_public_path__ + "img/_54A6780.81f6063c.jpg";